import * as React from 'react';

import {TruncatedItems} from './truncated-items';

/**
 * We get different attributes depending on the object type, usually `name` for
 * entities (things with an API ID) and a string `value` for everything else.
 */
type TokenizedRowItem = {
    name?: string;
    value?: string;
};

/**
 * Returns a string value based on which attributes TokenizedRowItem has.
 *
 * @param {TokenizedRowItem} item The API item being rendered.
 * @returns {string|undefined} The string value, or undefined.
 */
function getValue(row: TokenizedRowItem): string | null | undefined {
    if (row) {
        return row.name || row.value;
    }

    return null;
}

type Props = {
    value: TokenizedRowItem[];
};

export function Tokenized(props: Props) {
    return (
        // @ts-expect-error
        <TruncatedItems
            value={props.value}
            isTokenized={true}
            renderRow={(row: TokenizedRowItem) => {
                return getValue(row) || null;
            }}
        />
    );
}
